"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaAuthProvider = exports.SOLANA_MAINNET_CHAIN_REF = exports.SOLANA_DEVNET_CHAIN_REF = exports.SOLANA_TESTNET_CHAIN_REF = void 0;
const caip_1 = require("caip");
const util_1 = require("./util");
const uint8arrays = __importStar(require("uint8arrays"));
const sha256 = __importStar(require("@stablelib/sha256"));
exports.SOLANA_TESTNET_CHAIN_REF = '4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z';
exports.SOLANA_DEVNET_CHAIN_REF = 'EtWTRABZaYq6iMfeYKouRu166VU2xqa1';
exports.SOLANA_MAINNET_CHAIN_REF = '5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp';
class SolanaAuthProvider {
    constructor(provider, address, chainRef) {
        this.provider = provider;
        this.address = address;
        this.chainRef = chainRef;
        this.isAuthProvider = true;
    }
    async accountId() {
        return new caip_1.AccountID({
            address: this.address,
            chainId: `solana:${this.chainRef}`,
        });
    }
    async authenticate(message) {
        if (!this.provider.signMessage) {
            throw new Error(`Unsupported provider; provider must implement signMessage`);
        }
        const signatureBytes = await this.provider.signMessage(uint8arrays.fromString(message));
        const digest = sha256.hash(signatureBytes);
        return `0x${uint8arrays.toString(digest, 'base16')}`;
    }
    async createLink(did) {
        if (!this.provider.signMessage) {
            throw new Error(`Unsupported provider; provider must implement signMessage`);
        }
        const { message, timestamp } = util_1.getConsentMessage(did, true);
        const accountID = await this.accountId();
        const signatureBytes = await this.provider.signMessage(uint8arrays.fromString(message));
        const signature = uint8arrays.toString(signatureBytes, 'base64');
        return {
            version: 2,
            type: 'solana',
            message,
            signature,
            account: accountID.toString(),
            timestamp,
        };
    }
    withAddress(address) {
        return new SolanaAuthProvider(this.provider, address, this.chainRef);
    }
}
exports.SolanaAuthProvider = SolanaAuthProvider;
//# sourceMappingURL=solana.js.map